<template>
    <div class="campaign-item-tooltip">
        <div v-if="campaign.counter" class="counter align-items-center mb-2">
            <i class="col-auto p-0 ecom-clock prz-time"></i>
            <div class="col-auto text-center campaign-timer pl-1">
                <Counter :date="campaign.dateEnd" :useDays="false" ></Counter>
            </div>
        </div>
        <div v-if="campaign.type == 'coupon' " class="d-flex row mx-0 tooltip-info">
            <div class="col-auto px-0">
                <span class="coupon-title ">{{campaign.labelHtml.toLowerCase().trim() | strippedContent}} </span>
            </div>
            <div class="coupon-container col px-0">
                <div class="coupon-label">
                    <span>{{campaign.couponId}}</span>
                    <CopyToClipboard v-if="campaign.type == 'coupon'" :value="campaign.couponId" :kStrings="kStrings" @input="copied" />
                </div>
                <div class="coupon-text-info">
                    <span class="coupon-code">{{kStrings.kINFO_CPN_CODE}}</span>
                </div>
            </div>
        </div>
        <div v-else class="row mx-0 tooltip-info">
            <span class="coupon-title col-12 pl-0">{{campaign.labelHtml.toLowerCase().trim() | strippedContent}} </span>
        </div>
        <hr>
        <div class="tooltip-content">
            <span class="tooltip-title">{{kStrings.kDONT_FORGET}}</span>
            <br>
            <span v-html="campaign.phrase"></span>
            <br>
            <br>
            <div v-if="campaign.conditions">
                <span v-for="conditions in campaign.conditions " :key="conditions.couponRule">
                    <span v-html="conditions.couponRuleText"></span>
                    <br>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import Counter from '@/components/Muffin/Counter';
import CopyToClipboard from '@/components/Muffin/CopyToClipboard';
export default {
    name: 'CampaignDetails',
    components:{
        Counter,
        CopyToClipboard
    },
    props:{
        campaign: {
            type: Object,
            default: {}
        },
        kStrings: {
            type: Object, 
            default: {}
        },
    },
    computed: {},
    filters: {
        strippedContent: function(string) {
            return string ? string.replace(/<\/?[^>]+>/ig, " ") : '';  
        }
    },
    methods:{
        copied(){
            this.$emit('copied', true);
        }
    }
}
</script>
